import { Card } from '@mantine/core'
import cx from 'classnames'
import classes from './NewPromotionCard.module.scss'

type NewPromotionCardProps = {
  active: boolean
  children: JSX.Element
  onClick: () => void
}

export const NewPromotionCard = ({ active, children, onClick }: NewPromotionCardProps) => {
  return (
    <Card
      className={cx(classes.root, active ? classes.checked : undefined)}
      radius="sm"
      p="md"
      onClick={onClick}
      opacity={active ? 1 : 0.3}
      withBorder
    >
      {children}
    </Card>
  )
}
